import * as React from 'react';
import { Caps } from '../ui';

interface TextareaProps {
  className?: string;
  value?: string;
  id?: string;
  hasError?: boolean;
  label?: string;
  name?: string;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  wrapperClassName?: string;
  disabled?: boolean;
}

const Textarea: React.FunctionComponent<TextareaProps> = ({
  className = '',
  id,
  hasError = false,
  label,
  wrapperClassName = '',
  ...rest
}) => (
  <label htmlFor={id} className={`db ${wrapperClassName}`}>
    {label && <Caps className="dib fw5 light-tan mb3">{label}</Caps>}
    <textarea
      id={id}
      className={`input h4 ba ${hasError ? 'b--blue' : 'b--transparent'} ${className}`}
      {...rest}
    />
  </label>
);

export default Textarea;
